var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.show && _vm.jobProfile
    ? _c("div", { class: _vm.slideInClass }, [
        _c("header", { staticClass: "titled" }, [
          _c("div", [
            _c("h4", [_vm._v(_vm._s(_vm.title || _vm.inquiryToEdit.label))]),
            _vm._v(" "),
            _vm.subTitle
              ? _c("h3", { domProps: { innerHTML: _vm._s(_vm.subTitle) } })
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "close-container" }, [
            _c(
              "a",
              {
                attrs: { href: "#" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.closeFan({ confirmed: false })
                  }
                }
              },
              [_c("Icon", { attrs: { icon: "close" } })],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _c(
          "main",
          { staticClass: "scrollbar-check flex-grow-1" },
          [
            _vm.inquiryToEdit && _vm.inquiryToEdit.id === "function"
              ? _c("Function", {
                  attrs: { meta: _vm.meta },
                  model: {
                    value: _vm.inquiryData,
                    callback: function($$v) {
                      _vm.inquiryData = $$v
                    },
                    expression: "inquiryData"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.inquiryToEdit && _vm.inquiryToEdit.id === "function-detail"
              ? _c("FunctionDetail", {
                  attrs: { meta: _vm.meta },
                  model: {
                    value: _vm.inquiryData,
                    callback: function($$v) {
                      _vm.inquiryData = $$v
                    },
                    expression: "inquiryData"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.inquiryToEdit && _vm.inquiryToEdit.id === "function-assistance"
              ? _c("FunctionAssistance", {
                  attrs: { meta: _vm.meta },
                  model: {
                    value: _vm.inquiryData,
                    callback: function($$v) {
                      _vm.inquiryData = $$v
                    },
                    expression: "inquiryData"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.inquiryToEdit && _vm.inquiryToEdit.id === "function-legal-field"
              ? _c("FunctionLegalField", {
                  attrs: { meta: _vm.meta },
                  model: {
                    value: _vm.inquiryData,
                    callback: function($$v) {
                      _vm.inquiryData = $$v
                    },
                    expression: "inquiryData"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.inquiryToEdit && _vm.inquiryToEdit.id === "function-legal-role"
              ? _c("FunctionLegalRole", {
                  attrs: { meta: _vm.meta },
                  model: {
                    value: _vm.inquiryData,
                    callback: function($$v) {
                      _vm.inquiryData = $$v
                    },
                    expression: "inquiryData"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.inquiryToEdit && _vm.inquiryToEdit.id === "function-tax-field"
              ? _c("FunctionTaxField", {
                  attrs: { meta: _vm.meta },
                  model: {
                    value: _vm.inquiryData,
                    callback: function($$v) {
                      _vm.inquiryData = $$v
                    },
                    expression: "inquiryData"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.inquiryToEdit && _vm.inquiryToEdit.id === "function-tax-role"
              ? _c("FunctionTaxRole", {
                  attrs: { meta: _vm.meta },
                  model: {
                    value: _vm.inquiryData,
                    callback: function($$v) {
                      _vm.inquiryData = $$v
                    },
                    expression: "inquiryData"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.inquiryToEdit &&
            _vm.inquiryToEdit.id === "function-marketing-role"
              ? _c("FunctionMarketingRole", {
                  attrs: { meta: _vm.meta },
                  model: {
                    value: _vm.inquiryData,
                    callback: function($$v) {
                      _vm.inquiryData = $$v
                    },
                    expression: "inquiryData"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.inquiryToEdit && _vm.inquiryToEdit.id === "career-level"
              ? _c("CareerLevel", {
                  attrs: { meta: _vm.meta },
                  model: {
                    value: _vm.inquiryData,
                    callback: function($$v) {
                      _vm.inquiryData = $$v
                    },
                    expression: "inquiryData"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.inquiryToEdit && _vm.inquiryToEdit.id === "industrial-sector"
              ? _c("IndustrialSector", {
                  attrs: { meta: _vm.meta },
                  model: {
                    value: _vm.inquiryData,
                    callback: function($$v) {
                      _vm.inquiryData = $$v
                    },
                    expression: "inquiryData"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.inquiryToEdit && _vm.inquiryToEdit.id === "organisational-area"
              ? _c("OrganisationalArea", {
                  attrs: { meta: _vm.meta },
                  model: {
                    value: _vm.inquiryData,
                    callback: function($$v) {
                      _vm.inquiryData = $$v
                    },
                    expression: "inquiryData"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.inquiryToEdit && _vm.inquiryToEdit.id === "employment-mode"
              ? _c("EmploymentMode", {
                  attrs: { meta: _vm.meta },
                  model: {
                    value: _vm.inquiryData,
                    callback: function($$v) {
                      _vm.inquiryData = $$v
                    },
                    expression: "inquiryData"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.inquiryToEdit && _vm.inquiryToEdit.id === "hiring-date"
              ? _c("HiringDate", {
                  model: {
                    value: _vm.inquiryData,
                    callback: function($$v) {
                      _vm.inquiryData = $$v
                    },
                    expression: "inquiryData"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.inquiryToEdit && _vm.inquiryToEdit.id === "working-hours"
              ? _c("WorkingHours", {
                  model: {
                    value: _vm.inquiryData,
                    callback: function($$v) {
                      _vm.inquiryData = $$v
                    },
                    expression: "inquiryData"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.inquiryToEdit && _vm.inquiryToEdit.id === "employment-duration"
              ? _c("EmploymentDuration", {
                  model: {
                    value: _vm.inquiryData,
                    callback: function($$v) {
                      _vm.inquiryData = $$v
                    },
                    expression: "inquiryData"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.inquiryToEdit && _vm.inquiryToEdit.id === "place-of-work"
              ? _c("PlaceOfWork", {
                  model: {
                    value: _vm.inquiryData,
                    callback: function($$v) {
                      _vm.inquiryData = $$v
                    },
                    expression: "inquiryData"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.inquiryToEdit && _vm.inquiryToEdit.id === "home-office"
              ? _c("HomeOffice", {
                  model: {
                    value: _vm.inquiryData,
                    callback: function($$v) {
                      _vm.inquiryData = $$v
                    },
                    expression: "inquiryData"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.inquiryToEdit && _vm.inquiryToEdit.id === "salary"
              ? _c("Salary", {
                  model: {
                    value: _vm.inquiryData,
                    callback: function($$v) {
                      _vm.inquiryData = $$v
                    },
                    expression: "inquiryData"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.inquiryToEdit && _vm.inquiryToEdit.id === "hourly-rate"
              ? _c("HourlyRate", {
                  model: {
                    value: _vm.inquiryData,
                    callback: function($$v) {
                      _vm.inquiryData = $$v
                    },
                    expression: "inquiryData"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.inquiryToEdit && _vm.inquiryToEdit.id === "company-type"
              ? _c("CompanyType", {
                  attrs: { meta: _vm.meta },
                  model: {
                    value: _vm.inquiryData,
                    callback: function($$v) {
                      _vm.inquiryData = $$v
                    },
                    expression: "inquiryData"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.inquiryToEdit && _vm.inquiryToEdit.id === "company-size"
              ? _c("CompanySize", {
                  attrs: { meta: _vm.meta },
                  model: {
                    value: _vm.inquiryData,
                    callback: function($$v) {
                      _vm.inquiryData = $$v
                    },
                    expression: "inquiryData"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.inquiryToEdit && _vm.inquiryToEdit.id === "management"
              ? _c("Management", {
                  attrs: { meta: _vm.meta },
                  model: {
                    value: _vm.inquiryData,
                    callback: function($$v) {
                      _vm.inquiryData = $$v
                    },
                    expression: "inquiryData"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.inquiryToEdit && _vm.inquiryToEdit.id === "customer-contact"
              ? _c("CustomerContact", {
                  attrs: { meta: _vm.meta },
                  model: {
                    value: _vm.inquiryData,
                    callback: function($$v) {
                      _vm.inquiryData = $$v
                    },
                    expression: "inquiryData"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.inquiryToEdit && _vm.inquiryToEdit.id === "working-time"
              ? _c("WorkingTime", {
                  attrs: { meta: _vm.meta },
                  model: {
                    value: _vm.inquiryData,
                    callback: function($$v) {
                      _vm.inquiryData = $$v
                    },
                    expression: "inquiryData"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.inquiryToEdit && _vm.inquiryToEdit.id === "overtime"
              ? _c("Overtime", {
                  attrs: { meta: _vm.meta },
                  model: {
                    value: _vm.inquiryData,
                    callback: function($$v) {
                      _vm.inquiryData = $$v
                    },
                    expression: "inquiryData"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.inquiryToEdit && _vm.inquiryToEdit.id === "parking"
              ? _c("Parking", {
                  attrs: { meta: _vm.meta },
                  model: {
                    value: _vm.inquiryData,
                    callback: function($$v) {
                      _vm.inquiryData = $$v
                    },
                    expression: "inquiryData"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.inquiryToEdit &&
            _vm.inquiryToEdit.id === "private-vehicle-company-usage"
              ? _c("PrivateVehicleCompanyUsage", {
                  attrs: { meta: _vm.meta },
                  model: {
                    value: _vm.inquiryData,
                    callback: function($$v) {
                      _vm.inquiryData = $$v
                    },
                    expression: "inquiryData"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.inquiryToEdit && _vm.inquiryToEdit.id === "company-car"
              ? _c("CompanyCar", {
                  attrs: { meta: _vm.meta },
                  model: {
                    value: _vm.inquiryData,
                    callback: function($$v) {
                      _vm.inquiryData = $$v
                    },
                    expression: "inquiryData"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.inquiryToEdit && _vm.inquiryToEdit.id === "driving-license"
              ? _c("DrivingLicense", {
                  attrs: { meta: _vm.meta },
                  model: {
                    value: _vm.inquiryData,
                    callback: function($$v) {
                      _vm.inquiryData = $$v
                    },
                    expression: "inquiryData"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.inquiryToEdit && _vm.inquiryToEdit.id === "pilot-license"
              ? _c("PilotLicense", {
                  attrs: { meta: _vm.meta },
                  model: {
                    value: _vm.inquiryData,
                    callback: function($$v) {
                      _vm.inquiryData = $$v
                    },
                    expression: "inquiryData"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.inquiryToEdit && _vm.inquiryToEdit.id === "public-transport"
              ? _c("PublicTransport", {
                  attrs: { meta: _vm.meta },
                  model: {
                    value: _vm.inquiryData,
                    callback: function($$v) {
                      _vm.inquiryData = $$v
                    },
                    expression: "inquiryData"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.inquiryToEdit && _vm.inquiryToEdit.id === "function-experience"
              ? _c("FunctionExperience", {
                  attrs: { meta: _vm.meta },
                  model: {
                    value: _vm.inquiryData,
                    callback: function($$v) {
                      _vm.inquiryData = $$v
                    },
                    expression: "inquiryData"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.inquiryToEdit &&
            _vm.inquiryToEdit.id === "function-legal-field-experience"
              ? _c("FunctionLegalFieldExperience", {
                  attrs: { meta: _vm.meta },
                  model: {
                    value: _vm.inquiryData,
                    callback: function($$v) {
                      _vm.inquiryData = $$v
                    },
                    expression: "inquiryData"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.inquiryToEdit &&
            _vm.inquiryToEdit.id === "function-legal-role-experience"
              ? _c("FunctionLegalRoleExperience", {
                  attrs: { meta: _vm.meta },
                  model: {
                    value: _vm.inquiryData,
                    callback: function($$v) {
                      _vm.inquiryData = $$v
                    },
                    expression: "inquiryData"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.inquiryToEdit &&
            _vm.inquiryToEdit.id === "function-tax-field-experience"
              ? _c("FunctionTaxFieldExperience", {
                  attrs: { meta: _vm.meta },
                  model: {
                    value: _vm.inquiryData,
                    callback: function($$v) {
                      _vm.inquiryData = $$v
                    },
                    expression: "inquiryData"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.inquiryToEdit &&
            _vm.inquiryToEdit.id === "function-tax-role-experience"
              ? _c("FunctionTaxRoleExperience", {
                  attrs: { meta: _vm.meta },
                  model: {
                    value: _vm.inquiryData,
                    callback: function($$v) {
                      _vm.inquiryData = $$v
                    },
                    expression: "inquiryData"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.inquiryToEdit &&
            _vm.inquiryToEdit.id === "function-marketing-role-experience"
              ? _c("FunctionMarketingRoleExperience", {
                  attrs: { meta: _vm.meta },
                  model: {
                    value: _vm.inquiryData,
                    callback: function($$v) {
                      _vm.inquiryData = $$v
                    },
                    expression: "inquiryData"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.inquiryToEdit &&
            _vm.inquiryToEdit.id === "career-level-experience"
              ? _c("CareerLevelExperience", {
                  attrs: { meta: _vm.meta },
                  model: {
                    value: _vm.inquiryData,
                    callback: function($$v) {
                      _vm.inquiryData = $$v
                    },
                    expression: "inquiryData"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.inquiryToEdit &&
            _vm.inquiryToEdit.id === "industrial-sector-experience"
              ? _c("IndustrialSectorExperience", {
                  attrs: { meta: _vm.meta },
                  model: {
                    value: _vm.inquiryData,
                    callback: function($$v) {
                      _vm.inquiryData = $$v
                    },
                    expression: "inquiryData"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.inquiryToEdit &&
            _vm.inquiryToEdit.id === "organisational-area-experience"
              ? _c("OrganisationalAreaExperience", {
                  attrs: { meta: _vm.meta },
                  model: {
                    value: _vm.inquiryData,
                    callback: function($$v) {
                      _vm.inquiryData = $$v
                    },
                    expression: "inquiryData"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.inquiryToEdit && _vm.inquiryToEdit.id === "language"
              ? _c("Language", {
                  attrs: { meta: _vm.meta },
                  model: {
                    value: _vm.inquiryData,
                    callback: function($$v) {
                      _vm.inquiryData = $$v
                    },
                    expression: "inquiryData"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.inquiryToEdit && _vm.inquiryToEdit.id === "software-main"
              ? _c("SoftwareMain", {
                  attrs: { meta: _vm.meta },
                  model: {
                    value: _vm.inquiryData,
                    callback: function($$v) {
                      _vm.inquiryData = $$v
                    },
                    expression: "inquiryData"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.inquiryToEdit && _vm.inquiryToEdit.id === "software-special"
              ? _c("SoftwareSpecial", {
                  attrs: { meta: _vm.meta },
                  model: {
                    value: _vm.inquiryData,
                    callback: function($$v) {
                      _vm.inquiryData = $$v
                    },
                    expression: "inquiryData"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.inquiryToEdit && _vm.inquiryToEdit.id === "skills"
              ? _c("Skills", {
                  attrs: { meta: _vm.meta },
                  model: {
                    value: _vm.inquiryData,
                    callback: function($$v) {
                      _vm.inquiryData = $$v
                    },
                    expression: "inquiryData"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.inquiryToEdit && _vm.inquiryToEdit.id === "benefits"
              ? _c("Benefits", {
                  attrs: { meta: _vm.meta, "job-profile": _vm.jobProfile },
                  model: {
                    value: _vm.inquiryData,
                    callback: function($$v) {
                      _vm.inquiryData = $$v
                    },
                    expression: "inquiryData"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.inquiryToEdit && _vm.inquiryToEdit.id === "search-status"
              ? _c("SearchStatus", {
                  attrs: { meta: _vm.meta },
                  model: {
                    value: _vm.inquiryData,
                    callback: function($$v) {
                      _vm.inquiryData = $$v
                    },
                    expression: "inquiryData"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.inquiryToEdit && _vm.inquiryToEdit.id === "travel-willingness"
              ? _c("TravelWillingness", {
                  attrs: { meta: _vm.meta },
                  model: {
                    value: _vm.inquiryData,
                    callback: function($$v) {
                      _vm.inquiryData = $$v
                    },
                    expression: "inquiryData"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.inquiryToEdit && _vm.inquiryToEdit.id === "citizenship"
              ? _c("Citizenship", {
                  attrs: { meta: _vm.meta },
                  model: {
                    value: _vm.inquiryData,
                    callback: function($$v) {
                      _vm.inquiryData = $$v
                    },
                    expression: "inquiryData"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.inquiryToEdit && _vm.inquiryToEdit.id === "education"
              ? _c("Education", {
                  attrs: { meta: _vm.meta, "with-title": false },
                  model: {
                    value: _vm.inquiryData,
                    callback: function($$v) {
                      _vm.inquiryData = $$v
                    },
                    expression: "inquiryData"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.inquiryToEdit && _vm.inquiryToEdit.id === "incognito-mode"
              ? _c("IncognitoMode", {
                  model: {
                    value: _vm.inquiryData,
                    callback: function($$v) {
                      _vm.inquiryData = $$v
                    },
                    expression: "inquiryData"
                  }
                })
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "footer",
          [
            _c("Button", {
              attrs: {
                text: "Speichern",
                disabled: !_vm.inquiryDataValid || _vm.saving,
                loading: _vm.saving,
                icon: "checkmark"
              },
              on: { click: _vm.save }
            })
          ],
          1
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }